import Folder from './Folder.js';
import ethereum from 'decentralized/ethereum.js';
import {getItemFromLink, getLinks} from 'decentralized/xanadu/getItemFromLink.js';
import {getRootFromLink} from 'decentralized/xanadu/getRootFromLink.js';

/**
   * Represents Xanadu style links as a folder
   * of depth 2

   > Sequence 1
   > Sequence 2
   v Sequence 3
     - Sound 1
     - Sound 2
     - Sound 3
     
  * 
  * Dynamically load the contents of a folder
  * using Xanadu.js when clicked
*/
 
class LinkFolder extends Folder {
    constructor(linkType, fromData, name, parent, depth=0) {
        super(name, parent, depth);
        this.linkType = linkType;
        this.fromData = fromData;
        this.isLoaded = false;
    }

    isDynamic() {
        return true;
    }

    async load(xanadu=ethereum.xanadu) {
        if (this.isRoot()) {
            await this.loadRoot(xanadu);
            return;
        }

        // use Xanadu to load
        let links = await getLinks(this.linkType, this.fromData);

        // need to systematically get the items
        // from this list
        
        for (let i in links) {
            let link = links[i];
            this.addItem(await getItemFromLink(
                this.linkType, this.fromData, link.toData));
        }

        this.isLoaded = true;
    }

    async loadRoot(xanadu=ethereum.xanadu) {
        let fetchedData = await getRootFromLink(
            this.linkType);

        fetchedData
            .map(
                data => new LinkFolder(this.linkType, data.getId(), data.getName(), this))
            .forEach(
                folder => this.addFolder(folder));

        this.isLoaded = true;
        return this;
    }
}

export default LinkFolder;
